export default "__VITE_ASSET__Bgo$FNtF__"